import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { useAppSelector } from '@reducers/index';
import { currentInitiative, getRootOrg } from '@selectors/initiative';
import { InitiativeDetails } from '@features/company-settings/InitiativeDetails';
import { BlockingLoader } from '@g17eco/atoms/loader';
import Dashboard, { DashboardRow, DashboardSection } from '@g17eco/molecules/dashboard';
import { ROUTES } from '@constants/routes';
import { MTAdminBreadcrumbs } from '../components/breadcrumbs/MTAdminBreadcrumbs';

export const CompanySettingsRoute = () => {
  const { path } = useRouteMatch();

  const rootOrg = useAppSelector(getRootOrg);
  const initiative = useAppSelector(currentInitiative);

  return (
    <>
      <Switch>
        <Route path={path}>
          {!rootOrg || !initiative ? (
            <BlockingLoader />
          ) : (
            <Dashboard className='company-settings__wrapper'>
              <DashboardRow>
                <MTAdminBreadcrumbs breadcrumbs={[{ label: 'Company Settings' }]} initiativeId={initiative._id} />
              </DashboardRow>
              <DashboardRow>
                <h3 className='pl-2'>Company settings</h3>
              </DashboardRow>
              <DashboardSection>
                <InitiativeDetails
                  rootOrg={rootOrg}
                  initiative={initiative}
                  bankingRoute={ROUTES.MATERIALITY_TRACKER_BANKING_SETTINGS}
                  stockExchangeRoute={ROUTES.MATERIALITY_TRACKER_STOCK_EXCHANGE_SETTINGS}
                />
              </DashboardSection>
            </Dashboard>
          )}
        </Route>
      </Switch>
    </>
  );
};
